import React from 'react'
import SocialWorkerHeader from './SocialWorkerHeader'
import SocialWorkerNavBar from './SocialWorkerNavBar'

const SocialWorkerPage = () => {
  return (
    <div className=' h-max'>
        <SocialWorkerNavBar />
        <SocialWorkerHeader />
    </div>
  )
}

export default SocialWorkerPage